var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX2Black({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20.58,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.2903C21.5 15.6665 16.8309 20.0806 11 20.0806C5.16908 20.0806 0.5 15.6665 0.5 10.2903C0.5 4.91416 5.16908 0.5 11 0.5C16.8309 0.5 21.5 4.91416 21.5 10.2903Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.588 14L7.24 10.256L4.564 6.464H5.692L7.864 9.536L9.856 6.464H10.996L8.38 10.244L11.092 14H9.94L7.756 10.988L5.716 14H4.588ZM12.0592 14V12.884C12.0592 12.448 12.1292 12.084 12.2692 11.792C12.4132 11.5 12.6132 11.258 12.8692 11.066C13.1292 10.874 13.4352 10.708 13.7872 10.568L15.2752 9.98C15.6592 9.824 15.9472 9.624 16.1392 9.38C16.3312 9.136 16.4272 8.832 16.4272 8.468C16.4272 8.084 16.2932 7.77 16.0252 7.526C15.7612 7.282 15.3912 7.16 14.9152 7.16C14.4432 7.16 14.0552 7.262 13.7512 7.466C13.4512 7.666 13.2792 7.968 13.2352 8.372H12.1912C12.2192 7.936 12.3472 7.566 12.5752 7.262C12.8072 6.958 13.1212 6.728 13.5172 6.572C13.9132 6.412 14.3752 6.332 14.9032 6.332C15.3872 6.332 15.8212 6.426 16.2052 6.614C16.5892 6.802 16.8912 7.062 17.1112 7.394C17.3352 7.722 17.4472 8.1 17.4472 8.528C17.4472 8.916 17.3752 9.254 17.2312 9.542C17.0872 9.83 16.8812 10.078 16.6132 10.286C16.3492 10.494 16.0352 10.672 15.6712 10.82L14.1472 11.432C13.7632 11.58 13.4752 11.758 13.2832 11.966C13.0912 12.174 12.9952 12.444 12.9952 12.776V13.136H17.3752V14H12.0592Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX2Black);
export default __webpack_public_path__ + "static/media/X2_Black.e46b737cb6e3f34713263b25ce85feee.svg";
export { ForwardRef as ReactComponent };